import { _Base } from "./_base";

export class Race extends _Base {
    begin?: any;
    end?: any;
    description?: string;
    referees?: any[] = [];
}